import { render } from "./BtnWrapperDockView.vue?vue&type=template&id=1d0d9546&scoped=true&ts=true"
import script from "./BtnWrapperDockView.vue?vue&type=script&lang=ts"
export * from "./BtnWrapperDockView.vue?vue&type=script&lang=ts"

import "./BtnWrapperDockView.vue?vue&type=style&index=0&id=1d0d9546&scoped=true&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d0d9546"]])

export default __exports__